/**
 * SpecialtyPharmacyStepTherapySection - Output section for SP step therapy (Drug only)
 *
 * Displays specialty pharmacy step therapy requirements and medications.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface SpecialtyPharmacyStepTherapySectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
}

export const SpecialtyPharmacyStepTherapySection: React.FC<
  SpecialtyPharmacyStepTherapySectionProps
> = ({ data, sectionId }) => {
  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>Drug Specialty Pharmacy Step Therapy</span>
          <SectionTriggerScore subsectionKey="specialty_pharmacy_step_therapy" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix="drug.specialty_pharmacy_step_therapy">
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Step Therapy Required"
              value={data?.specialty_pharmacy_step_therapy_required}
              fieldId="specialty_pharmacy_step_therapy_required"
            />
            <Field
              label="Method"
              value={data?.specialty_pharmacy_step_therapy_method}
              fieldId="specialty_pharmacy_step_therapy_method"
            />
            <Field
              label="Available Date"
              value={data?.specialty_pharmacy_step_therapy_available_date}
              fieldId="specialty_pharmacy_step_therapy_available_date"
            />
            <Field
              label="Session Start Date"
              value={data?.specialty_pharmacy_step_therapy_session_start_date}
              fieldId="specialty_pharmacy_step_therapy_session_start_date"
            />
            <div className="col-span-2">
              <Field
                label="Treatments Required"
                value={data?.specialty_pharmacy_step_therapy_treatments_required}
                fieldId="specialty_pharmacy_step_therapy_treatments_required"
              />
            </div>
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
